
import { useSelector } from "react-redux";
import approvedImage from "../assets/svg/approved.svg";
import CustomButton from './elements/CustomButton/CustomButton';


const StripUnauthorised = ({handleBackProfile}) => {
 const { loginDetails } = useSelector((state) => state.counter);
  return (
      <div className="h-[calc(100vh-150px)] flex items-end justify-center bg-[#4293C6] rounded-[30px] mt-1 p-2 xs:px-3 sm:p-8 lg:p-16  ">
        <div className="bg-[#F9FDFF] rounded-[30px] shadow-lg h-full p-10 w-full flex flex-col sm:flex-row items-center justify-center gap-8">

          {/* Left Section */}
          <div className=' w-full xl:w-[40%]'>
            <h2 className="text-2xl font-semibold text-[#222] mb-2">
              Dear {loginDetails?.name || "User"},
            </h2>
            <p className="text-[#222] mb-6">
              Your payment account has not been set up yet. To unlock all features, please complete your Stripe account setup in the profile section by selecting “Go to Profile.”
            </p>

            <div className='flex gap-3 mt-3'>
              <CustomButton
                customeClass="primary-custom-button w-[180px] h-[40px]"
                onClick={() => handleBackProfile()}
              >
                Go to profile
              </CustomButton>
            </div>
          </div>
          <div className='hidden lg:flex' >
            <img
              src={approvedImage}
              alt="Approval Illustration"
              className="w-full max-w-[600px] mx-auto"
            />
          </div>
        </div>
    </div>
  );
};

export default StripUnauthorised;
